export default function PrimaryButton({ children, type, className, onClick }) {
  return (
    <div>
      <button onClick={onClick} className={`btnStyle ${className}`} type={type}>
        {children}
      </button>
    </div>
  );
}
